const MIN_LATENCY_SAMPLE_MS = 100;
const MAX_LATENCY_SAMPLE_MS = 30_000;
const EWMA_PREVIOUS_WEIGHT = 0.7;
const EWMA_SAMPLE_WEIGHT = 0.3;
const MIN_CHILDREN_TIMEOUT_MS = 1800;
const MAX_CHILDREN_TIMEOUT_MS = 4500;
const CHILDREN_TIMEOUT_FACTOR = 0.65;
const MIN_PREFETCH_JOIN_WAIT_MS = 350;
const PREFETCH_JOIN_FACTOR = 0.4;

export const normalizeSuggestionLatencySample = (elapsedMs: number): number =>
  Math.max(MIN_LATENCY_SAMPLE_MS, Math.min(elapsedMs, MAX_LATENCY_SAMPLE_MS));

export const updateSuggestionLatencyEwma = (
  previousEwmaMs: number,
  elapsedMs: number,
): number =>
  Math.round(
    previousEwmaMs * EWMA_PREVIOUS_WEIGHT
      + normalizeSuggestionLatencySample(elapsedMs) * EWMA_SAMPLE_WEIGHT,
  );

export const getAdaptiveSuggestionChildrenTimeoutMs = (
  latencyEwmaMs: number,
): number =>
  Math.max(
    MIN_CHILDREN_TIMEOUT_MS,
    Math.min(MAX_CHILDREN_TIMEOUT_MS, Math.round(latencyEwmaMs * CHILDREN_TIMEOUT_FACTOR)),
  );

export const getSuggestionPrefetchJoinWaitMs = (
  latencyEwmaMs: number,
): number =>
  Math.max(
    MIN_PREFETCH_JOIN_WAIT_MS,
    Math.round(getAdaptiveSuggestionChildrenTimeoutMs(latencyEwmaMs) * PREFETCH_JOIN_FACTOR),
  );
